import { React, Select, useEffect} from '../../../imports/imports-packege';

const SelectList = ({ optionList, getSelectValue, value }) => {
    useEffect(() => {
        if (value) {
            getSelectValue(value);
        }
    }, [value]);

    return (
        <div>
            <Select
                isSearchable={false}
                readOnly
                styles={{
                    control: (baseStyles, state) => ({
                        ...baseStyles,
                        borderColor: '#363738',
                        backgroundColor: '#262626',
                        outlineColor: '#363738',
                    }),
                }}
                theme={(theme) => ({
                    ...theme,
                    borderRadius: 0,
                    colors: {
                        ...theme.colors,
                        primary25: '#242426',
                        primary: '#515154',
                    },
                })}
                options={optionList}
                onChange={(selectedOption) => getSelectValue(selectedOption.value)}
                value={optionList.find(option => option.value === value)}
                getOptionValue={(option) => option.value}
                getOptionLabel={(option) => option.label}
            />
        </div>
    );
};

export default SelectList;
